import React from 'react';
import styles from '../styles.module.css';

export const CustomButton = ({
  children,
  onClick,
  className = '',
  disabled = false,
  style = {},
}) => {
  const onClickHandler = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      style={style}
      type="button"
      className={`${className} ${disabled ? styles.disabled : ''}`}
      onClick={onClickHandler}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
